import { render, staticRenderFns } from "./SidebarLink.vue?vue&type=template&id=3611afb2"
import script from "./SidebarLink.vue?vue&type=script&lang=js"
export * from "./SidebarLink.vue?vue&type=script&lang=js"
import style0 from "./SidebarLink.vue?vue&type=style&index=0&id=3611afb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports